import * as React from 'react';

import { calculateLargestTransaction } from '../../../providers/TransactionsProvider';
import { toCurrency } from '../../../utils/formatting';
import { type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';

import type { ColumnTable } from 'arquero';

export interface ILargestTransactionRowProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
  colored?: boolean;
  showSign?: boolean;
  negateAmount?: boolean;
}

const LargestTransactionRow = ({
  transactions,
  dateRange,
  colored = false,
  showSign = false,
  negateAmount = false,
}: ILargestTransactionRowProps) => {
  const rawValue = React.useMemo(() => calculateLargestTransaction(transactions, dateRange), [transactions, dateRange]);

  const value = negateAmount ? -rawValue : rawValue;

  const valueClassName = React.useMemo(() => {
    if (colored) {
      return value >= 0 ? 'text-success-primary' : 'text-error-primary';
    }
    return '';
  }, [colored, value]);

  const formattedValue = toCurrency(value, { showSign });

  return (
    <Widget.Row variant="summary" label="Largest transaction" value={formattedValue} valueClassName={valueClassName} />
  );
};

export default LargestTransactionRow;
